package one.healthium.domain.paywall.models

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonNames
import one.healthium.domain.common.PlatformValueSerializer
import one.healthium.domain.common.TextStyle

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@SerialName("secured_with_itunes")
data class PaywallSecuredView(
    @JsonNames("id") override val id: String,
    @SerialName("config") val config: PaywallSecuredConfig,
) : PaywallScreenView

@Serializable
data class PaywallSecuredConfig(
    @SerialName("text") @Serializable(with = PlatformValueSerializer::class) val text: String? = null,
    @SerialName("text_label") val textLabel: TextStyle? = null,
)